export const labelConstants = {
  preferredDataFormatOptions: [
    { label: 'View Online', value: 'viewOnline', isDisabled: true },
    { label: 'Microsoft Excel', value: 'excel', isDisabled: false },
  ],
  emergencyGrantTypeOptions: [
    { label: 'Family Assistance', value: 'FA' },
    { label: 'Safety Net Assistance', value: 'SNA' },
    {
      label: 'Emergency Safety Net Assistance',
      value: 'ESNA',
    },
    {
      label: 'Emergency Assistance to Needy Families',
      value: 'EANF',
    },
    {
      label: 'Emergency Assistance to Adults (will be placed on Guarantee Program)',
      value: 'EAA',
    },
  ],

  emergencyGrantTypeOptionsPrograms: [
    { label: 'Family Assistance', value: 'FamilyAsst' },
    { label: 'Safety Net Assistance', value: 'SafetyNetAsst' },
    {
      label: 'Emergency Safety Net Assistance',
      value: 'EmerAsstNeedyFamilies',
    },
    {
      label: 'Emergency Assistance to Needy Families',
      value: 'EmerAsstAdults',
    },
  ],

  startGuranteeTypeOptions: [
    { label: 'Family Assistance', value: 'FamilyAsst' },
    { label: 'Safety Net Assistance', value: 'SafetyNetAsst' },
    {
      label: 'Emergency Assistance to Needy Families',
      value: 'EmerAsstNeedyFamilies',
    },
    {
      label: 'Emergency Assistance to Adults',
      value: 'EmerAsstAdults',
    },
  ],
  stopGuaranteeOptions: [
    { label: 'End Date:', value: 'endDate' },
    { label: "Last 'Billed-To' Date: ", value: 'lastbilleddate' },
  ],
  femaBillingOptions: [
    { label: 'Most Recent 30 Day Bill: {30DaysBill}', value: 'mostRecent30DayBill' },
    {
      label: 'Highest Bill in Last 12 Months: {last12MonthsBill}',
      value: 'highestBillInLast12Months',
    },
  ],
  swalAlertsLabels: {
    titleSuccess: 'Success',
    titleError: 'Error!',
    titleConfirmation: 'Confirmation',
    titleWarning: 'Warning!',
    OK: 'OK',
    override: 'Override',
    errorToaster: 'Mailbox Unavailable',
    errorText: 'We found some issue, Please contact system administrator',
    confirmationText: 'Are you sure you want to close the window?',
    confirmButtonText: 'Yes, close it',
    cancelButtonText: 'Cancel',
    iconSuccess: 'success',
    iconError: 'error',
    iconConfirmation: 'warning',
    cancel: 'Cancel',
    areYouSure: 'Are you sure you want to delete?',
    yesDoIt: 'Ok',
    noCancel: 'Cancel',
    deletedMessage: 'Deleted successfully!',
    createdMessage: 'Created successfully.',
    updatedMessage: 'Updated successfully.',
  },

  toasterLabels: {
    displayText: 'Please correct the highlighted error fields',
    displayTheme: 'colored',
    displayposition: 'top-right',
    saveUnaccounted: 'Saved successfully.',
    mailboxunavailable: 'Mailbox unavailable',
    emailSuccessMessege: 'Email sent Successfully',
    flRegHeapErrorText:
      'This account is not eligible for this transaction because there is an existing Regular HEAP grant within the past 120 days.',
    flEmergencyHeapErrorText:
      'This account is not eligible for this transaction because there is an existing Emergency HEAP grant within the past 120 days.',
    flRegHeapAmountErrorText:
      'The Regular HEAP Grant amount is over the cap of {{AtHEAPCap}}. Please update the grant amount.',
    flEmergyHeapAmountErrorText:
      'The Emergency HEAP Grant amount is over the cap of {{AtHEAPCap}}. Please update the grant amount.',
    flRegHeapAmountMinErrorText:
      'The Regular HEAP Grant amount is below the minimum of {{AtHEAPMin}}. Please update the grant amount.',
    flEmergyHeapAmountMinErrorText:
      'The Emergency HEAP Grant amount is below the minimum of {{AtHEAPMin}}. Please update the grant amount.',
    totalError:
      'The total grant amount is over the cap of {{AtHEAPCap}}. Please update the grant amounts.',
    dateError: 'To Date can not be greater than From Date.',
    textError: 'Please enter the text.',
  },

  formLabels: {
    electricBillHistory: 'Electric Bill History',
    gasBillHistory: 'Gas Bill History',
    holdInfoData: 'Hold Info Data',
    accountInformation: 'Account Information',
    emergencyGrantTimePeriod: 'Emergency Grant Time Period',
    emergencyGrantEffectivePeriod: 'Guarantee Program Effective Dates',
    electricMonthTotal: 'Electric 4 Month Total',
    dssStatus: 'DSS Status',
    gasMonthTotal: 'Gas 4 Month Total',
    customerPayments: 'Customer Payments',
    dvped: 'Direct Voucher Program Effective Date',
    gped: 'Guarantee Program Effective Date',
    calculatedGrantAmount: 'Calculated Grant Amount',
    customerBalanceDue: 'Customer Balance Due',
    totalGrantAmountDue: 'Total Grant Amount Due',
    eaa: 'EAA',
    activePA: 'ActivePA',
    holdHistory: 'Hold History',
    preferredDataFormat: 'Select how you would like to view or download the data',
    viewOnline: 'viewOnline',
    excel: 'excel',
    formCountyCode: 'countyCode',
    formStartDate: 'startDate',
    formEndDate: 'endDate',
    formSubmitLabel: 'Submit',
    formSubmitLabell: 'Submittt',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    formNextLabel: 'Next',
    backButton: 'Back',
    startDate: 'Start Date',
    fromDate: 'From Date:',
    toDate: 'To Date:',
    backToSelectionPage: 'Back To Selection',
    excelBtn: 'Download As Excel',
    noRecordsAvailable: 'No Records Available',
    tendayHoldReport: 'TenDayHoldReport',
    FEMAGrantReport: 'FEMAGrantReport',
    careShareGrantReport: 'CareShareGrantReport',
    guaranteeProgramReport: 'GuaranteeProgramReport',
    directvoucherprogramreport: 'DirectVoucherProgramReport',
    heapgrantreport: 'HEAPGrantReport',
    emergencygrantreport: 'EmergencyGrantReport',
    fillinthedetails: 'Fill in the details',
    pleaseverify: 'Please verify the information for this account and Submit.',
    info: 'Standard Care and Share Amount',
    generateReportDesc:
      'Select the type of report you want to generate, enter the required information and click submit.',
    reports: 'Reports',
    viewTypeDesc: 'Select how you would like to view or download the data',
    countyCode: 'County Code',
    dateRange: 'Date Range',
    noDataFound: 'There was no data for the dates specified.',
    noDataFoundForSearch: 'There was no data for the specified search.',
    search: 'Search',
    dssemergencygrantreport: 'DSS Grant Authorizations: Emergency Grant',
    dssemergencygrantreportSubTitle: 'This is available for one time only.',
    otheragencygrantscareandshare: 'Other Agency Grants: Care and Share Grant ',
    dssemergencygrantverification: 'DSS Grant Authorizations: Emergency Grant',
    femagrantverification: 'Other Agency Grants: FEMA Grant ',
    verification: 'Verification',
    femagrant: 'Other Agency Grants: FEMA Grant',
    grantType: 'Grant type',
    accInfo: 'Account Information',
    includeSupplierCharges: 'Include Supplier Charges',
    emergencygrantdetails: 'Please verify the information for this account and submit.',
    pleaseVerifiyInfo: 'Please verify the information for this account and submit.',
    startDirectVerifyInfo:
      'Please verify the information for this account and click Next.',
    billingDatesNDays: 'Billing Dates & Days',
    utilityCharges: 'Utility Charges',
    supplierCharges: 'Supplier Charges',
    downloadPDF: 'Download PDF',
    print: 'Print',
    printAll: 'Print All',
    submit: 'Submit',
    accountDetailsTitle: 'Account Inquiry: List of Available Accounts',
    accountDetailsSubTitle: 'Please select an account number to view its details.',
    startGuaranteeTitle: 'Programs: Start Guarantee ',
    startDirectTitle: 'Programs: Start Direct Voucher',
    outage: 'Outage',
    outageDashboard: 'Outage Dashboard',
    disclaimerDashboard: 'Disclaimer Dashboard',
    outageDetails: 'Outage Details',
    outageText: 'Outage Text',
    addOutageText: 'Add',
    updateOutageText: 'Update',
    addOutageButton: 'Add Outage',
    disclaimer: 'Disclaimer',
    disclaimerDetails: 'Disclaimer Details',
    disclaimerText: 'Disclaimer Text',
    bulletInBoard: 'Bulletin Board',
    bulletInBoardDashboard: 'Bulletin Board Dashboard',
    bulletInBoardDetails: 'Bulletin Board Details',
    addBulletInBoardButton: 'Add Bulletin Board',
    BulletInBoardRequest : "BulletInBoard",
    startGuaranteeSubTitle:
      'Please enter an account number to start participation in this program.',
    startGuaranteeFillIndetails:
      'Please verify the information for the account and click Next.',
    caseNumberField: 'caseNumber',
    fromDateField: 'fromDate',
    stopGuaranteeTitle: 'Programs: Stop Guarantee',
    stopGuaranteeSubTitle:
      'Please select an account number to stop participation in this program.',
    selectEndDate: 'Please select your choice of End Date: ',
    billingInformation: 'Billing Information',
    pleaseSelectOne: 'Please Select One:',
    fema30DaySuccessMessage:
      'The FEMA Grant has been applied. You have selected the most recent 30 day bill. The grant amount is $totalAmount. A 30 day hold has been placed on the account and is in effect until $effectiveDate.',
    femaHighestIn12MonthsSuccessMessage:
      'The FEMA Grant has been applied. You have selected the highest bill in the last 12 months. The grant amount is $totalAmount. A 30 day hold has been placed on the account and is in effect until $effectiveDate.',
    careAndShareSuccessMessage:
      'The Care & Share Grant has been applied. The grant amount is $totalAmount. A 30 day hold has been placed on the account and is in effect until $effectiveDate.',
  },
  formPlaceholders: {
    statePlaceholder: 'Select  State',
    MonthFirstWithSlash: 'MM/DD/YYYY',
  },
  errorMessages: {
    invalid: 'Invalid',
    min: 'Minimum length Required',
    max: 'Maximum length Exceeded',
    valid: 'Valid',
    fromDateRequired: 'From Date is required',
    toDateRequired: 'To Date is required',
    outageTextRequired: 'Outage Text is required',
    fromDateGreaterThanToDate: 'From Date cannot be greater than To Date',
    toDateLessThanFromDate: 'To Date cannot be less than From Date',
    startDateRequired: 'Start Date is required',
    endDateRequired: 'End Date is required',
    startDateGreaterThanToDate: 'Start Date cannot be greater than End Date',
    endDateLessThanStartDate: 'End Date cannot be less than Start Date',
    reportTypeRequired: 'Report Type is required',
    countyCodeRequired: 'County Code is required',
    reportEndDateRequired: 'Report End Date is required',
    parseDate: 'This data is not available prior to',
    maxRange: 'For, "All - 000" County Code, the maximum date range is 5 days.',
    maxRange31days: 'Please select maximum date range of 31 days.',
    viewOnlineCountyCode:
      ' A report for all counties (County Code: All) is only available in Microsoft Excel data format. You cannot view this much data online.',
    userIdRequired: 'User ID is required',
    passwordRequired: 'Password is required',
    errorescoRequired: 'Please Select ESCo',
    caseNumberRequired: 'Case Number is required',
  },
  formFields: {
    totalRecords: 'Total records: ',
    tendayholdreport: 'tendayholdreport',
    FEMAGrantReport: 'femagrantreport',
    caresharegrantreport: 'caresharegrantreport',
    guaranteeprogramreport: 'guaranteeprogramreport',
    directvoucherprogramreport: 'directvoucherprogramreport',
    heapgrantreport: 'heapgrantreport',
    emergencygrantreport: 'emergencygrantreport',
    countyCode: 'County Code:',
    startDate: 'Start Date:',
    endDate: 'End Date:',
    reportType: 'Report Type',
    dssStatus: 'DSS Status',
    caseNumber: 'Case Number',
    effectiveUntil: 'Effective Until',
    effectiveDate: 'Effective Date',
    currentBalanceDue: 'Current Balance Due',
    colon: ':',
  },
  selectedErrorType: 1, //0 - No Error, 1 - highlighted box,  2 - error below the textbox, 3 - both 1 and 2, 4 - output box
  calenderStartDate: '1900-01-01',
  guarantee: 'Guarantee',
  direct: 'DirectVoucher',
  start: 'Start',
  startProgramFunction: 'Start',
  stopProgramFunction: 'Stop',
  submitMessage:
    'This customer will be awarded a $totalgrantamountdue Emergency Grant and be placed on the Guarantee Program effective $StartDate through $EndDate.',
  submitFalseMessage:
    'This customer will be placed on a Guarantee Program effective $StartDate through $EndDate.',
  submitDirectMessage:
    'This customer will be awarded a $totalgrantamountdue Emergency Grant and be placed on the Direct Voucher Program effective $StartDate.',
  submitDirectFalseMessage:
    'This customer will be placed on the Direct Voucher Program effective $effectivedate.',
  loginPagelabels: {
    nationalGridLabel: 'nationalgrid',
    nyEnergySupply: 'NY Energy suppliers',
    energySupplietLogin: 'Energy supplier Login',
    enterLoginDetails: 'Enter the following details to securely log into your account.',
    userId: 'User ID',
    password: 'Password',
    needHelp: 'Need help?',
    contactus: 'Contact US',
    disclaimer: 'Disclaimer',
    login: 'Login',
  },
  loginPageFields: {
    userId: 'userId',
    password: 'password',
  },
  viewTypeOptions: {
    list: 'list',
    form: 'form',
  },
  heapGrantConstants: {
    formTitle: 'DSS Grant Authorizations: HEAP Grant',
    verificationTitle: 'DSS Grant Authorizations: HEAP Grant ',
    verificationSubTitle:
      'Please verify the account for HEAP Grant Authorization, complete the rest of the form and Submit.',
    warnText:
      'Please note that if you issue two Emergency HEAP Grants for a customer, enter them individually to insure proper posting of the payment to the customers account.',
    holdType: 'Hold Type',
    expirationDate: 'Expiration Date',
    amount: 'Amount',
    balanceDueText: 'Current Balance Due: ',
    formTitleText: 'Fill in the Details',
    grantTypeLabel: 'Grant Type',
    regularGrantLabel: 'Regular HEAP Grant',
    emergencyGrantLabel: 'Emergency HEAP Grant',
    regularGrantValue: 'regular',
    emergencyGrantValue: 'emergency',
    name: 'Name',
    accountNumber: 'Account Number',
    serviceAddress: 'Service Address',
    effectiveUntil: 'Effective Until',
    currentBalanceDue: 'Current Balance Due',
    totalGrantAmount: 'Total Grant Amount',
    back: 'Back',
    print: 'Print',
    grantAmount: 'Grant Amount',
    heldUntil: 'Held Until',
    successMessage: 'A HEAP Grant has been applied successfully.',
    forthisRecords: 'this for your records.',
    regularGrantAmount: 'regularGrantAmount',
    regularGrantAmountRequired: 'Regular Grant Amount Required',
    emergencyGrantAmount: 'emergencyGrantAmount',
    emergencyGrantAmountRequired: 'Emergency Grant Amount Required',
    casenumber: 'caseNumber',
    caseNumberRequired: 'Case Number is Required',
    isRegularHeapGrant: 'isRegularHeapGrant',
    isEmergencyHeapGrant: 'isEmergencyHeapGrant',
    grantTypeRequired: 'Please select a Grant Type',
    printMessage: 'Please print this page for your records.',
  },
  tenDayHoldConstants: {
    formTitle: 'DSS Appointments: 10-Day Hold',
    verificationTitle: 'DSS Appointments: 10-Day Hold ',
    verificationSubTitle: 'Please verify the account for 10-Day Hold and click Submit.',
    name: 'Name',
    accountNumber: 'Account Number',
    serviceAddress: 'Service Address',
    holdUntil: 'Hold Until',
    back: 'Back',
    print: 'Print',
    successMessage: 'A 10-Day hold has been placed on the account successfully.',
    forthisRecords: 'this for your records.',
  },
  emergencyGrantConstants: {
    readDateAndDays: 'Billing Dates and Days',
    nmcharges: 'Utility Charges',
    supplierCharges: 'Supplier Charges',
    holdType: 'Hold Type',
    expirationDate: 'Expiration Date',
    holdAmount: 'Hold Amount',
    emergencyAssistance:
      'Emergency Assistance to Adults (will be placed on Guarantee Program)',
    emergencyAssistanceValue: 'Emergency Assistance to Adults',
    ssiRecipient: 'SSI Recipient',
    ssiRecipientRequest: 'SSIRecipient',
    emergencyAssistanceError:
      'This account will automatically be placed on the Guarantee Program for six months.',
    startGuaranteeError:
      'This account requires a four month Emergency Grant. To apply, please complete the information below.',
    startDirectError:
      'This account requires a four month Emergency Grant. To apply, please complete the information below.',
    accountVerification: 'Please verify the information for the account and submit.',
    submitMessage:
      'This customer will be awarded a $EmergencyGrant Emergency Grant and can be placed on Guarantee Program effective $StartDate through $EndDate.',
  },
  regex: {
    // ssnPattern: /^(?!000|666|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/,
    ssnPattern: /^(\d{3}-?\d{2}-?\d{4}|XXX-XX-?\d{4})$/,
    accountPattern: /^\d{8,12}$/,
    ssnMaskingFormat: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  },
};
